/* --- Dependencies --- */
import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import track from "react-tracking";
class ThankYou extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div className="content content_bufferTopLg mix-content_centerText">
				<div className="wrapper wrapper_narrow">
					<div className="vr vr_x10">
						<h2 className="hdg js-pageHeader">
							<FormattedMessage id="thankYou.header" defaultMessage="Thank You"/>
						</h2>
					</div>
					<div className="vr vr_x4">
						<div className="text">
							<p>
								<FormattedMessage id="thankyou.message" defaultMessage={"Thank you for contacting DCM Services, LLC. We will review your submission. Any follow-up "
            + "communications will occur during our regular business hours."}/>
							</p>
						</div>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
/* Create and export container component that wraps PrivacyNotice for property binding */
export default track({ page: "ThankYou" }, { dispatchOnMount: true })(connect()(ThankYou));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/ThankYou.tsx